var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeFilled = function SvgHomeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.842 17.792h3.425c.575 0 1.041-.467 1.041-1.042V9.642h.409c.45 0 .833-.275.983-.7a1.03 1.03 0 0 0-.333-1.159l-6.717-5.35a1.04 1.04 0 0 0-1.292 0L2.633 7.75a1.017 1.017 0 0 0-.341 1.158c.15.425.533.7.983.7h.408v7.142c0 .575.467 1.042 1.042 1.042h3.442c.575 0 1.041-.467 1.041-1.042v-2.733H10.8v2.733c0 .575.467 1.042 1.042 1.042Z",
    fill: "current"
  })));
};
export default SvgHomeFilled;